<template>
	<v-container grid-list-xl generalSettingsScreen>
		<v-layout row wrap>
			<v-tabs slider-color="grey">
				<v-tab class="tab" :key="1" ripple>General</v-tab>
				<v-tab class="tab" :key="2" ripple>Documents</v-tab>
				<v-tab class="tab" :key="3" ripple>PDF's</v-tab>
				<v-tab class="tab" :key="4" ripple>Terms</v-tab>
				<v-tab class="tab" :key="5" ripple>Attachments Categories</v-tab>
				<v-tab class="tab" :key="6" ripple>Delivery</v-tab>
				<v-tab class="tab" :key="7" ripple>SO Template</v-tab>
				<v-tab class="tab" :key="8" ripple>PO Template</v-tab>
				<v-tab class="tab" :key="9" ripple>Quote Template</v-tab>
				<v-tab class="tab" :key="10" ripple>Lookup Config</v-tab>
				<v-tab-item class="pl-4 pr-4" :key="1">
					<v-container grid-list-xl>
						<v-layout row wrap>
							<v-flex lg3>
								<label class="blackLabel">Document Numbering</label>
								<v-select :items="document_numbering_items" label="Document Numbering" class="dropdown" v-model="userDocSetting" item-value="id" solo single-line></v-select>
							</v-flex>
							<v-flex xs3>
								<label class="blackLabel">Quote No. Prefix</label>
								<v-text-field label="Quote No. Prefix" v-model="userQuotePrefix" solo></v-text-field>
							</v-flex>
							<v-flex xs3>
								<label class="blackLabel">Order No. Prefix</label>
								<v-text-field label="Order No. Prefix" v-model="userOrderPrefix" solo></v-text-field>
							</v-flex>
							<v-flex xs3>
								<label class="blackLabel">Quote Expiry Date</label>
								<v-text-field name="input-1" v-model="userQuoteExpiry" label="Quote Expiry (days)" solo></v-text-field>
							</v-flex>
              <v-flex lg3>
                <label class="blackLabel">Default Customer Type</label>
                <v-select :items="default_customer_type" label="Default Customer Type" class="dropdown" v-model="defaultUserType" item-value="id" solo single-line></v-select>
              </v-flex>
              <v-flex lg3>
                <v-switch label="Installation Calculator" v-model="installationActive"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-switch label="Can Create Quote For Company" v-model="companyQuote"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-switch label="Branches Active" v-model="branchActive"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-switch label="Department Active" v-model="departmentActive"></v-switch>
              </v-flex>
              <v-flex lg6>
                <v-switch label="All Departments Share Statuses" v-model="departmentStatusShare"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-switch label="Has Stock Levels" v-model="hasStock"></v-switch>
              </v-flex>
              <v-flex lg6>
                <label class="blackLabel">Quote Status Denominator</label>
                <v-select :items="quote_status_change_order" label="Quote Status Denominator" class="dropdown" v-model="quoteStatusRankOrder" item-value="id" solo single-line></v-select>
              </v-flex>
              <v-flex lg6>
                <label class="blackLabel">Allowed File Type</label>
				<!--<span class="hints">Enter the file extension and seperate with a comma - Eg. .pdf, .jpg</span>-->
                <v-text-field label="Allowed File Types" v-model="userAllowedFileTypes" solo></v-text-field>
              </v-flex>
              <v-flex lg6>
                <label class="blackLabel">Maximum File Upload Size ( in MB )</label>
				<span class="hints">&nbsp;</span>
                <v-text-field label="Allowed File Types" v-model="maxFileUpload" solo></v-text-field>
              </v-flex>
              <v-flex lg6>
                <label class="blackLabel">Manufacturer Installer Name</label>
                <span class="hints">&nbsp;</span>
                <v-text-field label="Manufacturer Installer Name" v-model="installerName" solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <v-switch label="Hide Ecommerce Section" v-model="hideEcommerce"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-switch label="Hide Trailing Zeros" v-model="hideTrailingZeros"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-switch label="Hide Vendors For Edit Screen" v-model="hideVendors"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-switch label="PDF - Including VAT Totals" v-model="vatIncluding"></v-switch>
              </v-flex>
						</v-layout>
					</v-container>
				</v-tab-item>
				<v-tab-item class="pl-4 pr-4" :key="2">
					<v-container grid-list-xl>
						<v-layout row wrap>
							<v-flex lg6>
								<label class="blackLabel">Manufacturer Users</label>
								<v-radio-group row v-model="userManufacturerDoc">
									<v-radio style="width: 150px;" label="Estimate" value="Estimate"></v-radio>
									<v-radio label="Quote" value="Quote"></v-radio>
								</v-radio-group>
							</v-flex>
							<v-flex xs6>
								<label class="blackLabel">Customer Users</label>
								<v-radio-group row v-model="userCustomerDoc">
									<v-radio label="Estimate" value="Estimate"></v-radio>
									<v-radio label="Quote" value="Quote"></v-radio>
								</v-radio-group>
							</v-flex>
							<v-flex xs6>
								<label class="blackLabel">Specific Users</label>
								<v-radio-group row v-model="userSpecificDoc">
									<v-radio label="Estimate" value="Estimate"></v-radio>
									<v-radio label="Quote" value="Quote"></v-radio>
								</v-radio-group>
							</v-flex>
							<v-flex xs6>
								<label class="blackLabel">Public Users</label>
								<v-radio-group row v-model="userPublicDoc">
									<v-radio label="Estimate" value="Estimate"></v-radio>
									<v-radio label="Quote" value="Quote"></v-radio>
								</v-radio-group>
							</v-flex>
						</v-layout>
					</v-container>
				</v-tab-item>
				<v-tab-item class="pl-4 pr-4" :key="3">
					<v-container grid-list-xl>
						<v-layout row wrap>
							<v-flex lg4>
								<label class="blackLabel">Header Title Size</label>
								<v-select :items="header_title_items" label="Header Title Size" class="dropdown" v-model="userPdfFontsize" item-value="id" single-line solo></v-select>
							</v-flex>
							<v-flex lg4>
								<label class="blackLabel">Page Orientation</label>
								<v-select :items="page_orientation_items" label="Page Orientation" v-model="userPageOrientation" item-value="id" class="dropdown" single-line solo></v-select>
							</v-flex>
              <v-flex lg4>
                <v-switch label="Show Client Logo In Notification" v-model="showClientLogoNotification"></v-switch>
              </v-flex>
							<v-flex lg4>
								<v-switch label="Page Numbers" v-model="userPageNumbers"></v-switch>
							</v-flex>
              <v-flex lg4>
                <v-switch label="Show Quote Details in SO Document" v-model="docShowSoQuoteDetails"></v-switch>
              </v-flex>
              <v-flex lg4>
                <v-switch label="Show Quote Details in PO Document" v-model="docShowQuoteDetails"></v-switch>
              </v-flex>
              <v-flex lg4>
                <v-switch label="Show Customer Details in Document" v-model="docShowCustomerDetails"></v-switch>
              </v-flex>
              <v-flex lg4>
                <v-switch label="Show Customer Delivery Details in Document" v-model="docShowDeliveryDetails"></v-switch>
              </v-flex>
              <v-flex lg8>
                <label class="blackLabel">Manufacturer Address</label>
                <v-text-field label="Address" v-model="manufacturerAddress" multi-line solo></v-text-field>
              </v-flex>
						</v-layout>
					</v-container>
				</v-tab-item>
				<v-tab-item class="pl-4 pr-4" :key="4">
          <v-container grid-list-xl>
            <v-layout row wrap>
          <v-flex lg12>
              <v-switch label="Include Standard terms" v-model="userStandardTerms"></v-switch>
            </v-flex>
          <v-flex xs6>
            <label class="blackLabel">Buy More Link</label>
            <v-text-field label="Buy More Link" v-model="buyMoreLink" solo></v-text-field>
          </v-flex>
          <v-flex xs6>
            <label class="blackLabel">Terms and Conditions Link</label>
            <v-text-field label="Terms and Conditions Link" v-model="termsLink" solo></v-text-field>
          </v-flex>
            <v-flex xs12>
              <!--<v-text-field multi-line v-model="userTermsText" label="Terms text"></v-text-field<-->
              <Vueditor ref="utText" v-model="userTermsText"></Vueditor>
            </v-flex>
            </v-layout>
          </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4" :key="5">
            <v-container grid-list-xl>
              <v-layout row wrap>
              <v-flex lg10 v-if="catAdd == true">
                <v-text-field label="Category Name" v-model="catAddInput" solo></v-text-field>
                </v-flex>
                <v-flex lg1 v-if="catAdd == true">
                  <v-btn color="success" class="text-xs-right" style="top: -5px; right: 10px !important;" @click.stop="fncCancelAddCat()">Cancel</v-btn>
                </v-flex>
                <v-flex lg1 v-if="catAdd == true">
                  <v-btn :disabled="catAddInput == ''" color="success" class="text-xs-right" style="top: -5px;" @click.stop="fncAddCat()">Add</v-btn>
                </v-flex>
                <v-flex lg10 v-if="catEdit == true">
                  <v-text-field label="Category Name" v-model="catEditInput.name" solo></v-text-field>
                </v-flex>
                <v-flex lg1 v-if="catEdit == true">
                  <v-btn color="success" class="text-xs-right" style="top: -5px; right: 10px !important;" @click.stop="fncCancelAddCat()">Cancel</v-btn>
                </v-flex>
                <v-flex lg1 v-if="catEdit == true">
                  <v-btn :disabled="catEditInput == ''" color="success" class="text-xs-right" style="top: -5px;" @click.stop="fncUpdateCat()">Update</v-btn>
                </v-flex>
                <v-flex lg6 v-if="catAdd == false && catEdit == false" style="padding-bottom: 0px !important; margin-bottom: 0px !important;">
                  <v-btn color="success" class="text-xs-right" @click.stop="fncShowAddCat()">Add</v-btn>
                </v-flex>
                <v-flex lg2 v-if="catAdd == false && catEdit == false">
                </v-flex>
                <v-flex lg4 v-if="catAdd == false && catEdit == false">
                  <small>Update POD Document Category</small>
                  <v-select :items="attachmentCategories" label="Update POD Uploaded Category" class="dropdown" v-model="podCategory" @input="fncUpdatePodCategory" item-value="id" item-text="name" item- solo single-line></v-select>
                </v-flex>
                <v-flex lg12 v-if="catAdd == false && catEdit == false">
                  <v-data-table :headers="headers" ref="sortableTable" :items="attachmentCategories" hide-actions class="elevation-1 smallBody" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                    <template slot="items" slot-scope="props">
                      <tr class="sortableRow" id="rows">
                        <td width="80%">{{ props.item.name }}</td>
                        <td width="10%" v-if="props.item.id == 0" class="text-xs-right">-</td>
                        <td width="10%" v-else class="text-xs-right"><a @click.prevent="fncShowEditCategory(props.item.id)"><i class="material-icons">edit</i></a></td>
                        <td width="10%" v-if="props.item.id == 0" class="text-xs-right">-</td>
                        <td width="10%" v-else class="text-xs-right"><a @click.prevent="fncDeleteCategory(props.item.id, props.item.catCount)"><i class="material-icons">delete_forever</i></a></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4" :key="6">
          <v-container grid-list-xl>
            <v-layout row wrap>
              <!--<v-flex lg6>
                <label class="blackLabel">Collect / Delivery Selection</label>
                <v-select :items="collection_delivery" label="Select Collect / Delivery" class="dropdown" v-model="collectionDeliveryType" item-value="id" solo single-line></v-select>
              </v-flex>
              <v-flex lg6>
                <label class="blackLabel">DHL</label>
                <v-switch label="Does this use DHL for delivery" v-model="isDhl"></v-switch>
              </v-flex>-->
              <v-flex xs12>
                <h3>Collection</h3>
              </v-flex>
              <v-flex lg6>
                <v-switch label="Customer can collect" v-model="customerCanCollect"></v-switch>
              </v-flex>
              <v-flex xs6>
                <label class="blackLabel">Collection Alias</label>
                <v-text-field label="Collection Alias" v-model="collectionLabel" solo></v-text-field>
              </v-flex>
              <v-flex xs12>
                <h3>Delivery</h3>
              </v-flex>
              <v-flex lg6>
                <v-switch label="Products can be delivered" v-model="productsCanBeDelivered"></v-switch>
              </v-flex>
              <v-flex xs6>
                <label class="blackLabel">Delivery Alias</label>
                <v-text-field label="Delivery Alias" v-model="deliveryLabel" solo></v-text-field>
              </v-flex>
              <v-flex lg6>
                <label class="blackLabel">Delivery Options</label>
                <v-select :items="delivery_options" label="Delivery Options" class="dropdown" v-model="deliveryOptions" item-value="id" solo single-line></v-select>
              </v-flex>

            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4" :key="7">
          <v-flex lg12>
            <v-btn color="success" class="text-xs-right" @click.stop="fncPrintTest(soTemplate)">PRINT TEST</v-btn>
            <v-text-field label="Sales Order Template" rows="18" v-model="soTemplate" multi-line solo></v-text-field>
          </v-flex>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4" :key="8">
          <v-flex lg12>
            <v-btn color="success" class="text-xs-right" @click.stop="fncPrintTest(poTemplate)">PRINT TEST</v-btn>
            <v-text-field label="Purchase Order Template" rows="18" v-model="poTemplate" multi-line solo></v-text-field>
          </v-flex>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 quoteTemplate" :key="9">
          <v-flex lg12>
            <v-btn color="success" class="text-xs-right" @click.stop="fncPrintTest(quoteTemplate)">PRINT TEST</v-btn>
            <v-text-field label="Quote Document Template" rows="18" v-model="quoteTemplate" multi-line solo></v-text-field>
          </v-flex>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4" :key="10">
          <v-container grid-list-xl>
            <v-layout row wrap>
            <v-flex xs6>
              <label class="blackLabel">Client Domain</label>
              <v-text-field label="Client Domain" v-model="lookupClientDomain" solo></v-text-field>
            </v-flex>
              <v-flex xs6>
                <label class="blackLabel">Client ID</label>
                <v-text-field label="Client ID" v-model="lookupClientId" solo></v-text-field>
              </v-flex>
            <v-flex xs6>
              <label class="blackLabel">Client Secret</label>
              <v-text-field label="Client Secret" v-model="lookupClientSecret" solo></v-text-field>
            </v-flex>
            <v-flex xs6>
              <label class="blackLabel">Client User</label>
              <v-text-field label="Client User" v-model="lookupClientUser" solo></v-text-field>
            </v-flex>
            <v-flex xs6>
              <label class="blackLabel">Client Password</label>
              <v-text-field label="Client Password" v-model="lookupClientPassword" solo></v-text-field>
            </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
			</v-tabs>
			<div class="pl-4 pr-4 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
					<v-progress-circular indeterminate :width="3" :size="20" color="grey" v-if="userEditSettings" class="pt-3 loginLoader"></v-progress-circular>
					<v-btn color="success" class="text-xs-right" v-if="!userEditSettings" @click.stop="fncUpdateSettings">Save</v-btn>
				</div>
			</div>
			<v-flex lg12 class="requiredMessage">
				<small><strong>&nbsp;</strong></small>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
	  name: 'Settings',
	  data () {
			return {
				snack: true,
				hasEdited: false,
                userQuotePrefix: this.$store.getters.userQuotePrefix,
                installationActive: this.$store.getters.installationActive,
                userOrderPrefix: this.$store.getters.userOrderPrefix,
                userOrderPrefix: this.$store.getters.userOrderPrefix,
                defaultUserType: this.$store.getters.defaultUserType,
                userQuoteExpiry: this.$store.getters.userQuoteExpiry,
                userDocSetting: this.$store.getters.userDocSetting,
                userManufacturerDoc: this.$store.getters.userManufacturerDoc,
                userCustomerDoc: this.$store.getters.userCustomerDoc,
                userSpecificDoc: this.$store.getters.userSpecificDoc,
                userPublicDoc: this.$store.getters.userPublicDoc,
                userPdfFontsize: this.$store.getters.userPdfFontsize,
                userPageOrientation: this.$store.getters.userPageOrientation,
                userPageNumbers: this.$store.getters.userPageNumbers,
                showClientLogoNotification: this.$store.getters.showClientLogoNotification,
                userStandardTerms: this.$store.getters.userStandardTerms,
                buyMoreLink: this.$store.getters.buyMoreLink,
                termsLink: this.$store.getters.termsLink,
                userTermsText: this.$store.getters.userTermsText,
                companyQuote: this.$store.getters.companyQuote,
                branchActive: this.$store.getters.branchActive,
                departmentActive: this.$store.getters.departmentActive,
                departmentStatusShare: this.$store.getters.departmentStatusShare,
                hasStock: this.$store.getters.hasStock,
                quoteStatusRankOrder: this.$store.getters.quoteStatusRankOrder,
                userAllowedFileTypes: this.$store.getters.userAllowedFileTypes,
                maxFileUpload: this.$store.getters.maxFileUpload,
                installerName: this.$store.getters.installerName,
                hideEcommerce: this.$store.getters.hideEcommerce,
                hideTrailingZeros: this.$store.getters.hideTrailingZeros,
                hideVendors: this.$store.getters.hideVendors,
                vatIncluding: this.$store.getters.vatIncluding,
                docShowQuoteDetails: this.$store.getters.docShowQuoteDetails,
                docShowSoQuoteDetails: this.$store.getters.docShowSoQuoteDetails,
                docShowCustomerDetails: this.$store.getters.docShowCustomerDetails,
                docShowDeliveryDetails: this.$store.getters.docShowDeliveryDetails,
                manufacturerAddress: this.$store.getters.manufacturerAddress,
                collectionDeliveryType: this.$store.getters.collectionDeliveryType,
                collectionLabel: this.$store.getters.collectionLabel,
                deliveryLabel: this.$store.getters.deliveryLabel,
                isDhl: this.$store.getters.isDhl,
                customerCanCollect: this.$store.getters.customerCanCollect,
                productsCanBeDelivered: this.$store.getters.productsCanBeDelivered,
                deliveryOptions: this.$store.getters.deliveryOptions,
                poTemplate: this.$store.getters.poTemplate,
                soTemplate: this.$store.getters.soTemplate,
                quoteTemplate: this.$store.getters.quoteTemplate,
                lookupClientDomain: this.$store.getters.lookupClientDomain,
                lookupClientUser: this.$store.getters.lookupClientUser,
                lookupClientPassword: this.$store.getters.lookupClientPassword,
                lookupClientSecret: this.$store.getters.lookupClientSecret,
                lookupClientId: this.$store.getters.lookupClientId,
                podCategory: this.$store.getters.podCategory,
                default_customer_type: [
                  { id: 2, text: 'Customer User' },
                  { id: 4, text: 'Public User' }
                ],
				document_numbering_items: [
					{ id: 'INCREMENT', text: 'Increment (QU000001 etc)' },
					{ id: 'EPOCH', text: 'Epoch Value (current time to seconds)' }
				],
        quote_status_change_order: [
          { id: '0', text: 'Quote Status is the lowest possible linked status' },
          { id: '1', text: 'Quote Status is the highest possible linked status' }
        ],
        delivery_options: [
          { id: 'free', text: 'Free Delivery' },
          { id: 'calculated_by_mo', text: 'Delivery rates calculated by MyOrder' },
          { id: 'delivery_integration_service', text: 'Delivery Integration Service' }
        ],
				header_title_items: [
					{ id: 'SMALL', text: 'Small' },
					{ id: 'MEDIUM', text: 'Medium' },
					{ id: 'LARGE', text: 'Large' }
				],
				page_orientation_items: [
					{ id: 'PORTRAIT', text: 'Portrait' },
					{ id: 'LANDSCAPE', text: 'Landscape' }
				],
        headers: [
          { text: 'NAME', value: 'name', sortable: false, width: '80%'  },
          { text: 'EDIT', value: 'edit', sortable: false, width: '10%'  },
          { text: 'DELETE', value: 'delete', sortable: false, width: '10%'  }
        ],
        catAdd: false,
        catEdit: false,
        catAddInput: '',
        catEditInput: [],
			};
		},
    watch: {
      objAuthorize() {
        this.soTemplate = this.objAuthorize.so_template;
        this.poTemplate = this.objAuthorize.po_template;
        this.quoteTemplate = this.objAuthorize.quote_template;
      }
    },
		mounted() {

	    this.$store.dispatch('fncGetAttachmentCategories');

	    this.$store.dispatch('fncGetTemplates');

			return this.$refs.utText.setContent(this.userTermsText);
		},
    methods: {
      fncUpdatePodCategory() {
        this.$store.dispatch('fncUpdatePodCategory', this.podCategory);
      },
      fncPrintTest( html ) {
        this.$store.dispatch('fncPrintTest', html)
      },
      fncShowEditCategory( id ) {
        for( var c in this.attachmentCategories ) {
          if( this.attachmentCategories[c].id == id ) {
            this.catEditInput = this.attachmentCategories[c];
          }
        }
        this.catAdd = false;
        this.catEdit = true;
        this.catAddInput = '';
      },
	    fncShowAddCat() {
	      this.catAdd = true;
	      this.catAddInput = '';
	      this.catEditInput = '';
      },
      fncCancelAddCat() {
        this.catAdd = false;
        this.catEdit = false;
        this.catAddInput = '';
        this.catEditInput = '';
      },
      fncUpdateCat() {
        this.$store.dispatch({
          type: 'fncUpdateQuoteAttachmentCategory',
          catId: this.catEditInput.id,
          catName: this.catEditInput.name
        });
        this.catAdd = false;
        this.catEdit = false;
        this.catAddInput = '';
        this.catEditInput = '';
      },
      fncAddCat() {
        this.$store.dispatch({
          type: 'fncAddNewQuoteAttachmentCategory',
          catName: this.catAddInput
        });
        this.catAdd = false;
        this.catEdit = false;
        this.catAddInput = '';
        this.catEditInput = '';
      },
      fncDeleteCategory( catId, catCount ) {
        if( catCount > 0 ) {
          alert('Please Note:\nCategory cannot be deleted as it has attachments assigned');
        } else {
          var deleteConfirm = confirm('Are you sure you want to remove the category?');
           if(deleteConfirm === true) {
             this.$store.dispatch({
               type: 'fncDeleteAttachmentCategory',
               catId: catId
             })
           }
        }
      },
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncUpdateSettings() {
				this.$store.dispatch({
					type: 'fncUpdateSettings',
					settings: {
						userID: this.objAuthorize.id,
						userManufacturer: this.objAuthorize.manufacturer,
						userQuotePrefix: this.userQuotePrefix,
						userOrderPrefix: this.userOrderPrefix,
						userQuoteExpiry: this.userQuoteExpiry,
						userDocSetting: this.userDocSetting,
						userManufacturerDoc: this.userManufacturerDoc,
						userCustomerDoc: this.userCustomerDoc,
						userSpecificDoc: this.userSpecificDoc,
						userPublicDoc: this.userPublicDoc,
						userPdfFontsize: this.userPdfFontsize,
						userPageOrientation: this.userPageOrientation,
						userPageNumbers: this.userPageNumbers,
            userStandardTerms: this.userStandardTerms,
            buyMoreLink: this.buyMoreLink,
            termsLink: this.termsLink,
            default_user_type: this.defaultUserType,
            userTermsText: this.$refs.utText.getContent(),
            installationActive: this.installationActive == false ? 0 : 1,
            showClientLogoNotification: this.showClientLogoNotification == false ? 0 : 1,
            companyQuote: this.companyQuote == false ? 0 : 1,
            departmentActive: this.departmentActive == false ? 0 : 1,
            branchActive: this.branchActive == false ? 0 : 1,
            departmentStatusShare: this.departmentStatusShare == false ? 0 : 1,
            hasStock: this.hasStock == false ? 0 : 1,
            quoteStatusRankOrder: this.quoteStatusRankOrder,
            userAllowedFileTypes: this.userAllowedFileTypes,
            maxFileUpload: this.maxFileUpload,
            installerName: this.installerName,
            hideEcommerce: this.hideEcommerce == false ? 0 : 1,
            hideTrailingZeros: this.hideTrailingZeros == false ? 0 : 1,
            hideVendors: this.hideVendors == false ? 0 : 1,
            vatIncluding: this.vatIncluding == false ? 0 : 1,
            docShowQuoteDetails: this.docShowQuoteDetails == false ? 0 : 1,
            docShowSoQuoteDetails: this.docShowSoQuoteDetails == false ? 0 : 1,
            docShowCustomerDetails: this.docShowCustomerDetails == false ? 0 : 1,
            docShowDeliveryDetails: this.docShowDeliveryDetails == false ? 0 : 1,
            manufacturerAddress: this.manufacturerAddress,
            collectionLabel: this.collectionLabel,
            deliveryLabel: this.deliveryLabel,
            collectionDeliveryType: this.collectionDeliveryType,
            isDhl: this.isDhl == false ? 0 : 1,
            customerCanCollect: this.customerCanCollect == false ? 0 : 1,
            productsCanBeDelivered: this.productsCanBeDelivered == false ? 0 : 1,
            deliveryOptions: this.deliveryOptions,
            poTemplate: this.poTemplate,
            soTemplate: this.soTemplate,
            quoteTemplate: this.quoteTemplate,
            lookupClientDomain: this.lookupClientDomain,
            lookupClientUser: this.lookupClientUser,
            lookupClientPassword: this.lookupClientPassword,
            lookupClientSecret: this.lookupClientSecret,
            lookupClientId: this.lookupClientId,
					}

				});

			}
		},
		computed: {
		...mapGetters([
			'objAuthorize',
			'userEditSettings',
      'attachmentCategories'
		])
	},
	  }
</script>

<style scoped>
	@import './assets/css/shared.css'
</style>
